<template>
  <div class="checkout">
    <div class="checkout__content">
      <ContainerLeft />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import { injectPixelScript } from '@/utils/pixels/injectPixelScript'
import ContainerLeft from '@/views/Checkout/partials/ContainerLeft/Shopify/ContainerLeft.vue'
import checkCookieExists from '@/utils/checkCookieExists'
import checkColorTheme from '@/utils/checkColorTheme'

export default {
  name: 'CheckoutView',
  components: {
    ContainerLeft,
  },
  data() {
    return {
      showOfferBanner: false,
      showContainerRight: false,
    }
  },
  computed: {
    ...mapState('Checkout', {
      pixels: (state) => state.pixels,
      store_name: (state) => state.cart.store_name,
      settings: (state) => state.cart.settings,
      cartHash: (state) => state.cartHash,
    }),
    ...mapGetters('Cart', ['getIsInternational']),
  },
  watch: {
    getIsInternational(value) {
      if (value) {
        this.$i18n.locale = 'es'
      }
    },
    store_name: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.setStoreName()
        }
      },
    },
    settings: {
      deep: true,
      handler(newValue) {
        const { timer } = newValue
        if (timer && timer.enable) {
          this.showOfferBanner = timer.enable
        }
      },
    },
  },
  mounted() {
    this.setColorTheme()
    this.SET_CART_HASH(this.$router.currentRoute.query)
    this.loadingCartData()
  },
  methods: {
    ...mapActions('Checkout', ['states', 'fetchCartShopify', 'pixel']),
    ...mapMutations('Checkout', ['SET_STORE_ID', 'SET_COLOR_THEME', 'SET_CART_HASH']),
    getParamCartIdAndStoreId() {
      return this.$router.currentRoute.query
    },
    showHidePurchaseSummary() {
      this.showContainerRight = !this.showContainerRight
    },
    async loadingCartData() {
      try {
        await this.states()
        const { store, cart } = this.cartHash
        const storeId = parseInt(store, 10)

        await this.SET_STORE_ID(storeId)
        await this.fetchCartShopify(cart)
        await this.checkCookie()
        await this.loadCheckoutPixel()
      } catch (error) {
        this.$AmAlert({
          type: 'error',
          description: this.$t('steps.cardFetchErr'),
          autoHide: true,
        })
        throw new Error(error)
      }
    },
    async loadCheckoutPixel() {
      try {
        await this.pixel()

        if (this.pixels.length) {
          injectPixelScript(this.pixels, 'checkout')
        }
      } catch (error) {
        throw new Error(error)
      }
    },

    checkCookie() {
      if (!checkCookieExists('appmax_checkout_settings')) {
        this.createCookie()
        return
      }
      this.updateCookie()
    },
    createCookie() {
      const cartValue = this.getCartSelectedValues()
      this.$cookies.set('appmax_checkout_settings', cartValue)
      this.setColorTheme()
      this.setStoreName()
      this.showOffer()
    },
    updateCookie() {
      const cartValue = this.getCartSelectedValues()
      if (!_.isEqual(this.$cookies.get('appmax_checkout_settings'), cartValue)) {
        this.$cookies.remove('appmax_checkout_settings')
        this.createCookie()
        return
      }

      this.setColorTheme()
      this.setStoreName()
      this.showOffer()
    },
    getCartSelectedValues() {
      const values = {}
      const wantedProps = ['color', 'image', 'timer']
      wantedProps.forEach((val) => {
        values[val] = this.settings[val]
      })
      values.store_name = this.store_name
      return values
    },
    setColorTheme() {
      if (!checkCookieExists('appmax_checkout_settings')) {
        this.SET_COLOR_THEME(null)
        return
      }
      this.SET_COLOR_THEME(checkColorTheme(this.$cookies.get('appmax_checkout_settings').color))
    },
    setStoreName() {
      if (checkCookieExists('appmax_checkout_settings')) {
        document.title = `Checkout - ${this.$cookies.get('appmax_checkout_settings').store_name}`
        return
      }

      if (this.store_name) {
        document.title = `Checkout - ${this.store_name}`
      }
    },
    showOffer() {
      if (checkCookieExists('appmax_checkout_settings')) {
        const { timer } = this.$cookies.get('appmax_checkout_settings')
        this.showOfferBanner = timer.enable
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.checkout {
  display: flex;
  flex-direction: column;

  &__content {
    display: flex;
    min-height: 100vh;
  }
}
</style>
